import { reportTypes, serializedTypes } from '@/reports/types';
import { SerializedIpFraudReport } from '@/reports/types/serialized';
import isBlacklisted from '@/utils/isBlacklisted';

type IpFraudReportSerializer = (
  rawReport: reportTypes.Report
) => serializedTypes.SerializedIpFraudReport;

export function SerializeIpFraudReport(
  rawIpFraud: reportTypes.Report
): serializedTypes.SerializedIpFraudReport {
  let is_Blacklisted = false;

  if (rawIpFraud.meta?.report_info && rawIpFraud.meta.report_info.proxy_flags) {
    is_Blacklisted = isBlacklisted(rawIpFraud.meta.report_info.proxy_flags);
  }

  const data = rawIpFraud?.supporting?.networks?.[0];
  const security = data?.security;

  const serializedIpFraud: SerializedIpFraudReport = {
    rawData: rawIpFraud,
    isEmpty: !data,
    meta: rawIpFraud.meta,
    alertMe: rawIpFraud.meta?.alert_me || false,
    createdAt: rawIpFraud.meta?.created_at || '',
    isBlacklisted: is_Blacklisted,
    reportUpgraded: rawIpFraud.meta?.report_upgraded || false,
    id: rawIpFraud.meta?.permalink || '',
    address: data?.address,
    ip: data?.ip || 'Unknown',
    isp: data?.isp || 'Unknown',
    asn: data?.asn?.toString() || 'Unknown',
    host: data?.host || 'Unknown',
    isProxy: data?.is_proxy ?? undefined,
    isVpn: data?.is_vpn ?? undefined,
    isTor: data?.is_tor ?? undefined,
    isActiveVpn: data?.is_active_vpn ?? undefined,
    isActiveTor: data?.is_active_tor ?? undefined,
    organization: data?.organization || 'TOR Activity Unknown',
    isCrawler: data?.is_crawler ?? undefined,
    isMobile: data?.is_mobile ?? undefined,
    connectionType: data?.connection_type || 'Unknown',
    isSharedConnection: data?.is_shared_connection ?? undefined,
    isDynamicConnection: data?.is_dynamic_connection ?? undefined,
    timeZone: data?.time_zone ?? 'Unknown',
    security: {
      fraudScore: security?.fraud_score || 0,
      abuseVelocity: security?.abuse_velocity || 'Abuse Velocity Unknown',
      isRecentAbuse: security?.is_recent_abuse ?? undefined,
      isHighRiskAttack: security?.is_high_risk_attack ?? undefined,
      isSecurityScanner: security?.is_security_scanner ?? undefined,
      isTrustedNetwork: security?.is_trusted_network ?? undefined,
      isBotStatus: security?.is_bot_status ?? undefined,
      isFrequentAbuser: security?.is_frequent_abuser ?? undefined,
    },
  };

  return serializedIpFraud;
}

export class IpFraudReport {
  public data: serializedTypes.SerializedIpFraudReport;

  constructor(
    rawData: reportTypes.Report,
    serializer: IpFraudReportSerializer = SerializeIpFraudReport
  ) {
    this.data = serializer(rawData);
  }
}
